// Copyright (c) StrangeBee 2024

import { classList } from '@Helpers/className';
import { Input, InputProps } from 'antd';
import React, { ReactElement, ReactNode } from 'react';
import { Helper } from './Helper';

import './THInput.scss';

export interface THInputProps extends InputProps {
    borderless?: boolean;
    errorless?: boolean;
    containerClassname?: string;
    extraAction?: ReactNode;
}

export const THInput = ({
    borderless = false,
    errorless = false,
    className,
    containerClassname,
    autoComplete = 'off',
    addonBefore,
    extraAction,
    ...props
}: THInputProps): ReactElement => (
    <div className={classList('th-input__container', containerClassname)}>
        {addonBefore && <div className="th-input__prefix">{addonBefore}</div>}

        <Input
            className={classList('th-input', className, {
                'no-border': borderless,
                'no-error': errorless,
                prefix: !!addonBefore,
            })}
            size="large"
            {...props}
            status={errorless ? ('ok' as '') : props.status}
            autoComplete={autoComplete}
        />
        {extraAction && <div className="th-input__suffix">{extraAction}</div>}
    </div>
);

THInput.Helper = Helper;
